export default "__VITE_ASSET__DVDAEGmW__"